<template>
  <div class="school-address">
    <div class="school-address__content">
      <MapComponent :address="data.address" />
      <div class="school-address__info">
        <span class="school-address__info-title">{{ data.title }}</span>
        <ShopContactsComponent :data="data" />
        <span class="school-address__info-subtitle">{{ data.description }}</span>
        <router-link :to="{ name: 'catalog' }" class="btn btn--main btn--md btn--with-icon">
          <span>Смотреть все товары</span>
          <IconComponent name="arrow-right-1" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import MapComponent from "components/MapComponent.vue";
import IconComponent from "components/IconComponent.vue";
import ShopContactsComponent from "./ShopContactsComponent.vue";

export default {
  name: "ShopAddressComponent",
  props: {
    data: {
      type: Object,
    },
  },
  components: {
    ShopContactsComponent,
    MapComponent,
    IconComponent,
  },
};
</script>

<style lang="stylus">
.school-address {
  +below(480px) {
    padding 0
    background transparent
  }

  &__content {
    display: grid;
    grid-template-columns: 5fr 5fr
    grid-gap: 30px;
    +below(860px) {
      grid-template-columns: 1fr
    }

    .map {
      border-radius: var(--main_radius)
      overflow: hidden
      width 100%
      max-width 634px
      height 100vh
      max-height 531px
      +below(860px) {
        max-width 100%
      }
    }
  }

  &__info {
    &-list {
      display: flex
      flex-direction: column
      gap: 10px
    }

    &-title {
      display: flex;
      font-weight: 700;
      font-size: 1.5em
      line-height: 115%
      margin-top 30px
      margin-bottom: 30px;
    }

    &-subtitle {
      display: flex;
      margin-top: 30px;
      margin-bottom 30px
      font-size 1em
      line-height: 170%
    }
  }

  &__address {
    margin-bottom: 30px
  }
}
</style>
